module.exports = __webpack_public_path__ + "static/media/quarrytruck2_preview.a394ac7f.jpg";